import React from 'react';
import { map } from 'lodash';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectCurrentUser } from '@components/Auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderPrimary from '@components/HeaderPrimary';
import { useToast } from '@components/ToastProvider';

import SearchCorporateMember from './SearchCorporateMember';
import Dashboard from './Dashboard';
import Billing from './Billing';
import Policy from './Policy';
import PolicyDetails from './PolicyDetails';
import PolicyClaim from './PolicyClaim';
import PolicyRenewal from './PolicyRenewal';
import PersonalInfoPage from './PersonalInfoPage';
import PersonalInfoEditPage from './PersonalInfoEditPage';
import BillingDetails from './BillingDetails';
import Claim from './Claim';
import ClaimDetails from './ClaimDetails';
import ClaimAddDocuments from './ClaimAdditionalDocuments';
import ClaimEdit from './ClaimEdit';
import Password from './Password';
import MobileNumberPage from './MobileNumberPage';
import Vehicle from './Vehicle';
import VehicleDetails from './VehicleDetails';
import VehicleForm from './VehicleForm';
import Document from './Document';
import DocumentNew from './DocumentNew';
import DocumentDetails from './DocumentDetails';
import DocumentEdit from './DocumentEdit';
import OtpLink from './OtpLink';
import InsurancePolicyListPage from './InsurancePolicyListPage';
import InsurancePolicyDetailsPage from './InsurancePolicyDetailsPage';
import { CommissionList } from './CommissionList';
import { useActiveKey, useUserDashboard } from './hook';

const UserDashboardRoute = () => {
  const { items } = useUserDashboard();
  const activeKey = useActiveKey();
  const currentUser = useSelector(selectCurrentUser);
  const toast = useToast();

  if (activeKey !== 'mobileNumber' && currentUser && currentUser.status === 'pending' && !currentUser.mobileNumber) {
    toast.warning({ body: 'You must update mobile number to confirm your account.' });
    return <Navigate to={'mobile-number'} />;
  }

  return (
    <>
      <HeaderPrimary />
      <Container fluid className="my-4">
        <Row className="gy-4">
          <Col sm={3}>
            <ListGroup activeKey={activeKey}>
              {map(items, ({ key, to, icon, label }) => (
                <ListGroup.Item as={Link} action to={to} key={key} eventKey={key}>
                  <FontAwesomeIcon icon={icon} className="fa-fw me-2" />
                  {label}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
          <Col sm={9}>
            <Routes>
              <Route index element={<Dashboard />} />
              <Route path="search-corporate-member" element={<SearchCorporateMember />} />
              <Route path="commission-shares" element={<CommissionList />} />

              <Route path="billing" element={<Billing />} />
              <Route path="billing/:billingId" element={<BillingDetails />} />

              <Route path="policy" element={<Policy />} />
              <Route path="policy/:orderableType/:orderableId" element={<PolicyDetails />} />
              <Route path="policy/:orderableType/:orderableId/claim" element={<PolicyClaim />} />
              <Route path="policy/:orderableType/:orderableId/renewal" element={<PolicyRenewal />} />

              <Route path="insurance-policy" element={<InsurancePolicyListPage />} />
              <Route path="insurance-policy/:insurancePolicyId" element={<InsurancePolicyDetailsPage />} />

              <Route path="claim" element={<Claim />} />
              <Route path="claim/:claimableType/:claimableId" element={<ClaimDetails />} />
              <Route path="claim/:claimableType/:claimableId/add-documents" element={<ClaimAddDocuments />} />
              <Route path="claim/:claimableType/:claimableId/edit" element={<ClaimEdit />} />

              <Route path="password" element={<Password />} />
              <Route path="mobile-number" element={<MobileNumberPage />} />
              <Route path="otp-link" element={<OtpLink />} />

              <Route path="personal-info" element={<PersonalInfoPage />} />
              <Route path="personal-info/edit" element={<PersonalInfoEditPage />} />

              <Route path="vehicle" element={<Vehicle />} />
              <Route path="vehicle/:vehicleId" element={<VehicleDetails />} />
              <Route path="vehicle/:vehicleId/edit" element={<VehicleForm />} />

              <Route path="document" element={<Document />} />
              <Route path="document/new" element={<DocumentNew />} />
              <Route path="document/:id" element={<DocumentDetails />} />
              <Route path="document/:id/edit" element={<DocumentEdit />} />
            </Routes>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { UserDashboardRoute };
